<div
  [class]="`children-badge children-badge--${type}`"
  [matTooltip]="tooltip || ''"
>
  {{ count }}
</div>
